// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6350 ? "72a30a16" : chunkId) + "." + {"636":"2404f7a6aecdd6e9","6350":"796e743095e23e94","7856":"f8d49d65609a11f9"}[chunkId] + ".js";
};